import React from 'react';

import {
    gridPageCountSelector,
    gridPageSelector,
    gridPageSizeSelector,
    gridPaginationSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';

import BasicPagination from './BasicPagination';

const CustomPagination = (props) => {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
    const { rowCount = 0 } = useGridSelector(apiRef, gridPaginationSelector);

    return (
        <BasicPagination
            onChangePage={(newPage) => apiRef.current.setPage(newPage)}
            onChangePageSize={(newPageSize) =>
                apiRef.current.setPageSize(newPageSize)
            }
            page={page}
            pageCount={pageCount}
            pageSize={pageSize}
            rowCount={rowCount}
            {...props}
        />
    );
};

export default CustomPagination;
